// partcipants

import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  value: {},
  loading: false,
  error:{}
}

export const PartcipantactivitesSlice = createSlice({
  name: 'Partcipantactivites',
  initialState,
  reducers: {
    Partcipant_Activites_request: (state, action) => {
      state.value = {};
      state.loading = true;
    },
    Partcipant_Activites_success: (state, action) => {

      state.value = action.payload;
      state.loading = false;
      state.error = {};

    },
    Partcipant_Activites_failure: (state, action) => {
      state.error = action.payload;
      state.loading = false;
      state.value = {};
    },
    Clear_Partcipant_Activites_Check: (state, action) => {
      state.value = {}
      state.error = {};
      state.loading = false;
    },
  }
})

// Action creators are generated for each case reducer function
export const {Partcipant_Activites_request, Partcipant_Activites_success, Partcipant_Activites_failure, Clear_Partcipant_Activites_Check } = PartcipantactivitesSlice.actions

export default PartcipantactivitesSlice.reducer